import styled from 'styled-components';
import { Z_INDEX_APP_NAV_BAR, HIDDEN_PRINT } from '../../../components/commander-ui/constants';

export const AppNavbarElement = styled.div`
    ${HIDDEN_PRINT}
    z-index: ${Z_INDEX_APP_NAV_BAR};
`;
